module.exports = __webpack_public_path__ + "static/media/HouseSmartVideoDesignSmart.7ef7f7b0.jpg";